module.exports = __webpack_public_path__ + "img/icon-step-8.ca8e9a88.png";